<template>
  <div class="container">
    <img
      src="https://w1.lavamusic.com/h5/雙十一_1031_h5.png"
      alt=""
    />
    <p
      @click="
        toTB('https://shop.m.taobao.com/shop/sr.htm?p=2Ik4Hv_80XeE_0_onyw4')
      "
      style="top: 17.638%"
    >
    </p>
    <p
      class="pp"
      @click="
        toTB(
          'https://shop.m.taobao.com/shop/sr.htm?p=2Ik4Hv_80XeE_0_onyw4'
        )
      "
      style="top: 38.638%"
    ></p>
    <p
      class="pp"
      @click="
        toTB(
          'https://shop.m.taobao.com/shop/sr.htm?p=2Ik4Hv_80XeE_0_onyw4'
        )
      "
      style="top: 47.12%"
    ></p>
    <p
      class="pp"
      @click="
        toTB(
          'https://shop.m.taobao.com/shop/sr.htm?p=2Ik4Hv_80XeE_0_onyw4'
        )
      "
      style="top: 57.45%"
    ></p>
    <p
      class="pp"
      @click="
        toTB(
          'https://shop.m.taobao.com/shop/sr.htm?p=2Ik4Hv_80XeE_0_onyw4'
        )
      "
      style="top: 65.96%"
    ></p>
    <p
      class="pp"
      @click="
        toTB(
          'https://shop.m.taobao.com/shop/sr.htm?p=2Ik4Hv_80XeE_0_onyw4'
        )
      "
      style="top: 76.75%"
    ></p>
    <p
      class="pp"
      @click="
        toTB(
          'https://shop.m.taobao.com/shop/sr.htm?p=2Ik4Hv_80XeE_0_onyw4'
        )
      "
      style="top: 85.3%"
    ></p>
  </div>
</template>
<script>
import dsBridge from "dsbridge";
export default {
  name: "TB20221027",
  setup() {
    const toTB = (url) => {
      const ua = navigator.userAgent;
      if (ua.includes("LAVA")) {
        dsBridge.call("openAction", {
          pageType: 5,
          url,
        });
      } else {
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.click();
        console.log(a);
        a.remove();
      }
    };
    return {toTB};
  },
};
</script>
<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  height: auto;
  // background: #fef8cf;
}

.container > img {
  width: 100%;
  vertical-align: middle;
  object-fit: fill;
}

.container > p {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 7.5vw;
  width: 26vw;
  border-radius: 3.5vw;
  text-align: center;
}

.container > p > a {
  display: block;
  width: 100%;
  height: 100%;
}

.pp {
  width: 15vw !important;
}
</style>
